/* global axios */
import ApiClient from './ApiClient';

class InboxSlaPolicies extends ApiClient {
  constructor() {
    super('', { accountScoped: true });
  }

  getUrl(inboxId) {
    return `${this.apiVersion}/accounts/${this.accountIdFromRoute}/inboxes/${inboxId}/inbox_sla_policies`;
  }

  get(inboxId) {
    return axios.get(this.getUrl(inboxId));
  }

  create(inboxId, data) {
    return axios.post(this.getUrl(inboxId), data);
  }

  update(inboxId, policyId, data) {
    return axios.put(`${this.getUrl(inboxId)}/${policyId}`, data);
  }

  delete(inboxId, policyId) {
    return axios.delete(`${this.getUrl(inboxId)}/${policyId}`);
  }
}

export default new InboxSlaPolicies();
